(function() {
    'use strict';

    angular.module('order').controller('OrderProductEditModalController', OrderProductEditModalController);

    OrderProductEditModalController.$inject = [
        '$uibModalInstance',
        'orderProduct',
        'orderProductDataSrvc',
        'productDataSrvc',
        'notificationSrvc',
        'errorNotificationSrvc',
        'orderUpdateMessagesConst'
    ];

    function OrderProductEditModalController(
        $uibModalInstance, orderProduct, orderProductDataSrvc, productDataSrvc, notificationSrvc,
        errorNotificationSrvc, orderUpdateMessagesConst
    ) {
        var self = this;

        self.orderProduct = orderProduct;
        self.loading = false;
        self.productGroupOptionsOpts = [];
        self.productQuantityOpts = orderProduct.product_quantities || [];
        self.useCustomQuantity = !orderProduct.selected_quantity_pk;
        self.selectedQuantity = null;
        self.userQuantity = orderProduct.user_quantity || null;
        self.selectedProductOptions = {};
        self.optionUserValues = {};
        self.serverErrors = {};

        self.isMultipleGroupOption = isMultipleGroupOption;
        self.getSelectedOptionsWithInput = getSelectedOptionsWithInput;
        self.groupHasOptionWithInput = groupHasOptionWithInput;
        self.ok = ok;
        self.cancel = cancel;

        activate();

        function activate() {
            self.selectedQuantity = self.productQuantityOpts.filter(function(quantity) {
                return quantity.pk === orderProduct.selected_quantity_pk;
            })[0] || null;

            self.loading = true;
            productDataSrvc.getProductGroupOptions({pk: orderProduct.product_pk}).$promise.then(
                function(response) {
                    self.productGroupOptionsOpts = response;
                    initSelectedOptions();
                }
            ).finally(function() {
                self.loading = false;
            });
        }

        function initSelectedOptions() {
            self.selectedProductOptions = {};
            self.optionUserValues = {};

            self.productGroupOptionsOpts.forEach(function(g_opt) {
                var groupPk = g_opt.group_option.pk;
                var isMultiple = isMultipleGroupOption(g_opt.group_option);
                var chosenForGroup = (orderProduct.chosen_options || []).filter(function(chosen) {
                    return chosen.chosen_option.group_pk === groupPk;
                });

                var matchedOptions = chosenForGroup.map(function(chosen) {
                    var option = g_opt.options.filter(function(opt) {
                        return opt.pk === chosen.chosen_option.pk;
                    })[0];

                    if (!option) {
                        return null;
                    }

                    if (option.enter_values_possible) {
                        self.optionUserValues[option.pk] = chosen.user_value;
                    }

                    return option;
                }).filter(function(option) {
                    return option !== null;
                });

                if (matchedOptions.length === 0) {
                    if (isMultiple) {
                        self.selectedProductOptions[groupPk] = [];
                    }
                    return;
                }

                self.selectedProductOptions[groupPk] = isMultiple ? matchedOptions : matchedOptions[0];
            });
        }

        function isMultipleGroupOption(group) {
            return group.is_multiple;
        }

        function getSelectedOptionsWithInput(groupPk) {
            var selected = self.selectedProductOptions[groupPk];

            if (!selected) {
                return [];
            }

            var options = angular.isArray(selected) ? selected : [selected];
            return options.filter(function(option) {
                return option && option.enter_values_possible;
            });
        }

        function groupHasOptionWithInput(g_opt) {
            return (g_opt.options || []).some(function(option) {
                return option.enter_values_possible === true;
            });
        }

        function getChosenOptionsPayload() {
            var payload = [];

            angular.forEach(self.selectedProductOptions, function(value) {
                if (!value) {
                    return;
                }

                var options = angular.isArray(value) ? value : [value];
                options.forEach(function(option) {
                    payload.push({
                        chosen_option: option.pk,
                        user_value: option.enter_values_possible ? self.optionUserValues[option.pk] : null
                    });
                });
            });

            return payload;
        }

        function getValidationError() {
            if (!self.useCustomQuantity && !self.selectedQuantity) {
                return 'Wybierz nakład.';
            }

            if (self.useCustomQuantity && (self.userQuantity === null || self.userQuantity === undefined || self.userQuantity < 0)) {
                return 'Podaj poprawny własny nakład.';
            }

            var missingGroupName = null;

            self.productGroupOptionsOpts.forEach(function(g_opt) {
                if (missingGroupName || groupHasOptionWithInput(g_opt)) {
                    return;
                }

                var selected = self.selectedProductOptions[g_opt.group_option.pk];
                if (!selected || (angular.isArray(selected) && selected.length === 0)) {
                    missingGroupName = g_opt.group_option.name;
                }
            });

            if (missingGroupName) {
                return 'Wybierz opcję dla: ' + missingGroupName + '.';
            }

            var optionValueError = null;

            angular.forEach(self.selectedProductOptions, function(value) {
                var options = angular.isArray(value) ? value : (value ? [value] : []);
                options.forEach(function(option) {
                    if (optionValueError || !option.enter_values_possible) {
                        return;
                    }

                    var userValue = self.optionUserValues[option.pk];

                    if (userValue === null || userValue === undefined) {
                        optionValueError = 'Podaj wartość dla opcji "' + option.label + '".';
                        return;
                    }

                    if (
                        (option.min_value !== null && option.min_value !== undefined && userValue < option.min_value) ||
                        (option.max_value !== null && option.max_value !== undefined && userValue > option.max_value)
                    ) {
                        optionValueError = 'Wartość opcji "' + option.label + '" musi być w zakresie ' +
                            option.min_value + '-' + option.max_value + '.';
                    }
                });
            });

            return optionValueError;
        }

        function ok() {
            var validationError = getValidationError();
            if (validationError) {
                notificationSrvc.notification('error', validationError);
                return;
            }

            var payload = {
                selected_quantity: self.useCustomQuantity ? null : (self.selectedQuantity ? self.selectedQuantity.pk : null),
                user_quantity: self.useCustomQuantity ? self.userQuantity : null,
                chosen_options: getChosenOptionsPayload()
            };

            self.loading = true;
            orderProductDataSrvc.adminUpdate({pk: self.orderProduct.pk}, payload).$promise.then(
                function(response) {
                    notificationSrvc.notification('success', orderUpdateMessagesConst.productUpdated);
                    $uibModalInstance.close(response);
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            ).finally(function() {
                self.loading = false;
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
